//Global External Imports
import React from "react";
import {Grid, Box} from '@mui/material'
import {DragDropContext} from 'react-beautiful-dnd';

//Global Internal Imports

//Child Imports
import Liste from "./Liste";

function Gruppe(props) {
  //Standardfelder
  const {felder, formular, id, liste, FeldBearbeiten, ChangeGruppe, CopyFeld} = props;

  //Arbeitsfelder

  //Standardfunktionen

  //Arbeitsfunktionen
  function onDragStart(start){
  
  }

  function onDragEnd(result){
    const {source, destination}=result;
      if (!destination){
        return
      }

      if (source.droppableId===destination.droppbaleId&&source.index===destination.index){
        return
      }
        const newArray=Array.from(liste);
        newArray.splice(source.index,1);
        newArray.splice(destination.index,0,liste[source.index]);
        ChangeGruppe(newArray)
  }

  function FeldOnClick(arg,feld,liste,index){
   if (arg.altKey){
    CopyFeld(feld,index)
   } else {
    FeldBearbeiten(feld)
   }
    
  }

  //Renderfunktionen  
  function renderListe(){
    const tmpListe=liste.filter((item)=>felder[formular][item]).map((key)=>{
      return(felder[formular][key])    
    })
    return(
      <Grid item xs={12}>
        <Liste id={id} name="Gruppenaufbau" felder={tmpListe} dropDisabled={false} onClick={FeldOnClick}/>
      </Grid>
    )
  }

  //Rückgabe
  return(
    <Box p={3}>
      <DragDropContext
        onDragStart={(s)=>onDragStart(s)}
        onDragEnd={(r)=>onDragEnd(r)}
      >
        <Grid container justifyContent="flex-start" spacing={5}>
          {renderListe()}
        </Grid>
      </DragDropContext>
      
    </Box>
  )

}

export default Gruppe;
